import { ReactElement } from 'react';
import CustomTooltip from './CustomTooltip';
import './ExternalSchoolTag.css';

interface ExternalSchoolTagProps {
  variant?: 'ext' | 'external';
  showTooltip?: boolean;
  isInteractive?: boolean;
}

const ExternalSchoolTag = ({ variant = 'ext', showTooltip = true, isInteractive = true }: ExternalSchoolTagProps) => {
  const tagText = variant === 'ext' ? 'EXT' : 'EXTERNAL';
  const tooltipTitle = (
    <>
      External School
      <br />
      Non-EOAA institution providing course credits.
    </>
  ) as ReactElement;

  const tag = (
    <span
      className={`external-school-tag external-school-tag--${variant} ${!isInteractive ? 'external-school-tag--non-interactive' : ''}`}
    >
      {tagText}
    </span>
  );

  if (showTooltip) {
    return (
      <CustomTooltip title={tooltipTitle} placement="top" arrow={true}>
        {tag}
      </CustomTooltip>
    );
  }

  return tag;
};

export default ExternalSchoolTag;
